(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hadrill-clip-video-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialise(root) {
    if (root.dataset.clipUgcReady) return;
    root.dataset.clipUgcReady = 'true';
    const track = root.querySelector('[data-clip-ugc-track]');
    const videos = Array.from(root.querySelectorAll('video'));
    const previous = root.querySelector('[data-clip-ugc-prev]');
    const next = root.querySelector('[data-clip-ugc-next]');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;
    const visible = new Map();
    let active = null, manual = null, stopped = false, frame = null;
    function poster(video) {
      if (video.dataset.clipUgcPoster) { video.poster = video.dataset.clipUgcPoster; delete video.dataset.clipUgcPoster; }
    }
    function pauseOthers(selected) { videos.forEach(video => { if (video !== selected) { video.pause(); video.muted = true; sync(video); } }); }
    function play(video) {
      active = video;
      pauseOthers(video);
      if (!video) return;
      poster(video);
      if (!video.getAttribute('src')) { video.src = video.dataset.clipUgcSrc; video.load(); }
      const attempt = video.play();
      if (attempt && attempt.then) attempt.then(() => { if (active !== video || document.hidden) video.pause(); }).catch(() => sync(video));
    }
    function sync(video) {
      const media = video.closest('.clip-ugc__media');
      const toggle = media.querySelector('[data-clip-ugc-toggle]');
      const sound = media.querySelector('[data-clip-ugc-sound]');
      toggle.setAttribute('aria-label', video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
      toggle.querySelector('[data-clip-ugc-play]').hidden = !video.paused;
      toggle.querySelector('[data-clip-ugc-pause]').hidden = video.paused;
      sound.setAttribute('aria-label', video.muted ? sound.dataset.unmuteLabel : sound.dataset.muteLabel);
      sound.setAttribute('aria-pressed', String(!video.muted));
      media.querySelector('[data-sound-muted]').toggleAttribute('hidden', !video.muted);
      media.querySelector('[data-sound-audible]').toggleAttribute('hidden', video.muted);
    }
    function choose() {
      if (document.hidden) { play(null); return; }
      const candidates = videos.filter(video => (visible.get(video) || 0) >= .35);
      if (manual && candidates.includes(manual)) { if (active !== manual) play(manual); return; }
      manual = null;
      if (stopped || motion.matches || (connection && connection.saveData)) { play(null); return; }
      const bounds = track.getBoundingClientRect();
      const centre = (Math.max(0, bounds.left) + Math.min(window.innerWidth, bounds.right)) / 2;
      candidates.sort((a,b) => { const ar = a.getBoundingClientRect(), br = b.getBoundingClientRect(); return Math.abs((ar.left + ar.right) / 2 - centre) - Math.abs((br.left + br.right) / 2 - centre); });
      if ((candidates[0] || null) !== active) play(candidates[0] || null);
    }
    function navigation() { root.querySelector('.clip-ugc__navigation').hidden = videos.length < 2; previous.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; }
    function move(direction) {
      const card = root.querySelector('.clip-ugc__card');
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
      track.scrollBy({left: direction * step, behavior: motion.matches ? 'auto' : 'smooth'});
    }
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1);
    });
    root.addEventListener('click', event => {
      const toggle = event.target.closest('[data-clip-ugc-toggle]');
      const sound = event.target.closest('[data-clip-ugc-sound]');
      if (!toggle && !sound) return;
      const video = (toggle || sound).closest('.clip-ugc__media').querySelector('video');
      if (sound) { const muted = video.muted; stopped = false; manual = video; play(video); video.muted = !muted; sync(video); }
      else if (!video.paused) { stopped = true; manual = null; play(null); }
      else { stopped = false; manual = video; play(video); }
    });
    videos.forEach(video => { video.addEventListener('play', () => sync(video)); video.addEventListener('pause', () => sync(video)); video.addEventListener('volumechange', () => sync(video)); });
    if ('IntersectionObserver' in window) {
      const posters = new IntersectionObserver(entries => { entries.forEach(entry => { if (entry.isIntersecting) { poster(entry.target); posters.unobserve(entry.target); } }); }, {rootMargin: '300px 300px'});
      const observer = new IntersectionObserver(entries => { entries.forEach(entry => visible.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0)); choose(); }, {threshold:[0,.35,.6,1]});
      videos.forEach(video => { posters.observe(video); observer.observe(video); });
    } else videos.forEach(poster);
    track.addEventListener('scroll', () => { navigation(); if (!frame) frame = requestAnimationFrame(() => { frame = null; choose(); }); }, {passive:true});
    document.addEventListener('visibilitychange', choose);
    window.addEventListener('resize', navigation, {passive:true});
    if (motion.addEventListener) motion.addEventListener('change', choose);
    if (connection && connection.addEventListener) connection.addEventListener('change', choose);
    navigation();
  }
  document.querySelectorAll('[data-clip-ugc]').forEach(initialise);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-clip-ugc]').forEach(initialise));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mcp-hadrill-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.sliderReady) return;
    root.dataset.sliderReady='true';
    var track=root.querySelector('.hrev-slider__track');
    var controls=root.querySelector('.hrev-slider__controls');
    var prev=root.querySelector('[data-review-prev]');
    var next=root.querySelector('[data-review-next]');
    var reviews=Array.from(root.querySelectorAll('.hrev-slider__body')).map(function(body){
      var button=body.nextElementSibling;
      button.addEventListener('click',function(){
        var expanded=button.getAttribute('aria-expanded')!=='true';
        button.setAttribute('aria-expanded',String(expanded));
        button.textContent=expanded?button.dataset.less:button.dataset.more;
        body.classList.toggle('is-collapsed',!expanded);
      });
      return {body:body,button:button};
    });
    function updateReviews(){
      reviews.forEach(function(review){
        var expanded=review.button.getAttribute('aria-expanded')==='true';
        review.body.classList.toggle('is-collapsed',!expanded);
        var overflows=review.body.scrollHeight>parseFloat(getComputedStyle(review.body).lineHeight)*5+2;
        review.button.hidden=!overflows;
        if(!overflows) review.body.classList.remove('is-collapsed');
      });
    }
    function update(){
      var max=track.scrollWidth-track.clientWidth;
      controls.hidden=max<2;
      prev.disabled=track.scrollLeft<2;
      next.disabled=track.scrollLeft>=max-2;
    }
    function move(direction){
      var card=track.querySelector('.hrev-slider__card');
      if(!card) return;
      var gap=parseFloat(getComputedStyle(track).gap)||0;
      track.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
    prev.addEventListener('click',function(){move(-1)});
    next.addEventListener('click',function(){move(1)});
    track.addEventListener('scroll',update,{passive:true});
    track.addEventListener('keydown',function(e){if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1)}});
    var observer=new ResizeObserver(function(){update();updateReviews()}); observer.observe(track);
    if(document.fonts) document.fonts.ready.then(updateReviews);
    updateReviews();
    root.addEventListener('shopify:section:unload',function(){observer.disconnect()},{once:true});
    update();
  }
  function boot(){document.querySelectorAll('.hrev-slider').forEach(init)}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();
})();
